<template>
  <div class="pages" v-loading="listLoading">
    <div v-for='(item, index) in templateData.TemplateContent.Controls' :key='index'>
      <Digit v-if='item.Property.Control == "Number"' :data-val='item'></Digit>
      <Contact v-if='item.Property.Control == "Condition"' :data-val="item"></Contact>
      <Dates v-if='item.Property.Control == "Date"' :data-val="item"></Dates>
      <Version v-if='item.Property.Control == "Text"' @child-event='getTextVal' :data-val="item"></Version>
      <Money v-if='item.Property.Control == "Money"' :data-val="item"></Money>
      <Tips v-if='item.Property.Control == "Tips"' :data-val="item"></Tips>
      <File v-if='item.Property.Control == "File"' :data-val="item"></File>
      <Table v-if='item.Property.Control == "Table"' @child-event='tableOperation' :data-val='item'
        :template-data='templateData'></Table>
      <Selector v-if='item.Property.Control == "Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
      <Textarea v-if='item.Property.Control == "Textarea"' :data-val='item'></Textarea>
      <Choose v-if='item.Property.Control == "Contact"' @child-event='clickChoose' :data-val='item'></Choose>
    </div>
    <Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading"
      size="large" type="primary"> 提交
    </Button>
    <!-- <Button v-on:click="test">测试</Button> -->
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from '../components/Number.vue'
import Contact from '../components/Contact.vue';
import Dates from '../components/Date.vue';
import Version from '../components/Text.vue';
import Money from '../components/Money.vue';
import Tips from '../components/Tips.vue';
import File from '../components/File.vue';
import Table from '../components/Table.vue';
import Selector from '../components/Selector.vue';
import Textarea from '../components/Textarea.vue';
import Choose from '../components/Choose.vue';
import stringUtils from "../assets/js/stringUtil.js";
import { initWxConfig } from '../api/jssdk.js';
import { getTemplateInfo, submitProcess, getProcessContinuation, sendMessageFirstHand } from '@/api/approval'
import { getRelation } from '@/api/employee'
import { convertHump, getOptionValForDataVal, select } from '../utils/componentUtils'
import { findFirstHandByFlowId, updateState } from '@/api/firstHand'

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: []
  }
};
const sendMessagetTemplate = {
  title: null,
  url: null,
  toUser: [],
  desc: null,
  template: null,
};
export default {
  components: {
    Contact,
    Dates,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      flowId: null,
      formLoading: false,
      listLoading: false,
      sendMessageData: Object.assign({}, sendMessagetTemplate),
      isDisabled: false,
      tableId: [],
      isLegal: null,
      newTable: null,
      newFwTable: null,
      isReject: false,
      money: 0,
      // 备份营业起诉字段
      bfQS: null,
      // 备份发函字段
      bfFH: null,
      checkZHFH: false,
      checkZHQS: false,
      firstModel: null,
      selectState: null,
      djyShow: ["未收金额", "对应阶段", "是否发函", "是否法务起诉", "是否已开具发票", "是否已发法务/律师函", "预计实收日期", "第几次申请暂缓诉讼", "是否当月已和甲方核对佣金", "第几次申请暂缓发函"],
      //isZong: false // 逐级审批是否存在总经理
    }
  },
  created() {
    initWxConfig(this);
    this.logInfo = this.getLoginUserInfo();
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.flowId = this.$route.query.flowId;
    this.isLegal = this.$route.query.isLegal === "true";
    this.getTemplate();
    stringUtils.setAddIsShow(false);

  },
  methods: { //方法
    clickChoose(dataVal, name) {
      window.wx.invoke("selectEnterpriseContact", {
        "fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
        "mode": "single", // 必填，选择模式，single表示单选，multi表示多选
        "type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
        "selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        "selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
      }, function (res) {
        if (res.err_msg == "selectEnterpriseContact:ok") {
          if (typeof res.result == 'string') {
            res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
          }
        }
      })
    },
    /**
     * 在流程中????并且不是驳回
     */
    processUnder(flowId) {
      if (flowId !== null && flowId !== undefined) {
        return true
      }
    },
    test() {
      let results = []
      for (let control of this.templateData.TemplateContent.Controls.filter(e => e.Property.Title[0].Text.indexOf("达结佣条件") !== -1 && e.IsShow)) {
        for (let child of control.Config.Table.Children) {
          if (child.Property.Title[0].Text === "是否发函" || child.Property.Title[0].Text === "是否法务起诉") {
            let options = child.Config.Selector.Options;
            let value = child.Value
            let selectVal = ""
            for (let option of options) {
              if (option.Key === value) {
                selectVal = option.Value[0].Text
              }
            }
            if (selectVal && selectVal !== "") {
              results.push(selectVal)
            }
          }
        }
      }
      //let length = results.filter(e => e.indexOf("暂缓") !== -1).length;
      //this.isZong = length > 0;
    },
    getTemplate: async function () {
      this.listLoading = true;
      const that = this
      const { fullName, JobLevel, DeptName, EmpNo } = this.logInfo
      const departs = fullName.split("/");
      if (that.processUnder()) {
        this.Message({
          message: '流程缺失流程编号',
          type: 'error',
          duration: 1000
        });
        this.isDisabled = true
        return
      }
      const process = await getProcessContinuation(this.flowId)
      const body = process.Body
      if (body !== null) {
        switch (body.State) {
          // 流程通过
          case 100:
            this.Message({
              message: '此流程已审批通过',
              type: 'error',
              duration: 2000
            });
            this.isDisabled = true
            break
          // 已完成填写，在流程审批中
          case 300:
            this.Message({
              message: '此流程已填写完成',
              type: 'error',
              duration: 2000
            });
            this.isDisabled = true
            break
          //流程驳回
          default:
            break
        }
        this.isReject = true
        // 证明不是初次填写
        if (body.RequiredContinuationCocument !== null) {
          this.newTable = convertHump(body.RequiredContinuationCocument)
        }
        if (body.ProsecutionComponent !== null) {
          this.newFwTable = convertHump(body.ProsecutionComponent)
        }
      }
      // 获取数据
      that.firstModel = await findFirstHandByFlowId(this.flowId)
      that.firstModel = that.firstModel.Body
      await that.getEmployeeRelation(that.firstModel.FirstApprover[0])
      // await that.getEmployeeRelation("SC18010092")
      await getTemplateInfo(this.templateId).then(async response => {
        let template = response.Body;
        const {
          ProjectName, PartyAName, PartyANature, AmountNotReceived, HeadOfAccount,
          FirstApprover, CommissionRecoveryPeriod, Remark, ReachConditionList, File
        } = that.firstModel
        for (let item of template.TemplateContent.Controls) {
          const { Text } = item.Property.Title[0];
          if (Text === "逐级审批使用") {
            item.Values = await that.getRelationList(this.relationList, 8);
            item.Values = that.applyZhujishenpiValues(item.Values, "FirstHandEarlyWarningCheckForNew", { fullName: that.logInfo.fullName })
            item.IsShow = false
          }

          if (Text === "申请部门") {
            item.Value = DeptName
            item.Disable = true
          }
          if (Text === "申请人") {
            item.Value = EmpNo
            item.Disable = true
          }
          if (Text === "项目名称") {
            item.Value = ProjectName
            item.Disable = true
          }
          if (Text === "甲方名称") {
            item.Value = PartyAName
            item.Disable = true
          }
          if (Text === "甲方性质") {
            item.Value = PartyANature.Key
            item.Disable = true
          }
          if (Text === "业务系统未收总金额") {
            item.Value = AmountNotReceived
            this.money = AmountNotReceived
            item.Disable = true
          }
          if (Text === "台账负责人") {
            item.Value = HeadOfAccount[1]
            item.Values = []
            item.Values.push(HeadOfAccount)
            item.Disable = true
          }
          if (Text === "第一步审批人") {
            item.Value = FirstApprover[1]
            item.Values = []
            item.Values.push(FirstApprover)
            item.Disable = true
          }
          if (Text === "追佣时间段") {
            let keys = select(CommissionRecoveryPeriod, e => e.Key)
            item.Values = keys.map(e => [e])
            item.ValuesSelect = keys
            item.Disable = true
          }
          if (Text === "备注") {
            item.Value = Remark
            item.Disable = true
          }
          if (Text.indexOf("达结佣条件") > -1) {
            item.IsShow = false
            let table = item.Config.Table
            let tys = ["达结佣条件2个月（第二阶段）此阶段必须发函"]
            for (const reachCondition of ReachConditionList) {
              if (reachCondition.Title !== Text) {
                continue
              }
              item.IsShow = true
              // 拿到table 并赋值给子控件
              let amoun = table.Children.filter(e => e.Property.Title[0].Text === "未收金额")[0]
              let phase = table.Children.filter(e => e.Property.Title[0].Text === "对应阶段")[0]
              if (amoun) {
                amoun.Value = reachCondition.AmountNotCollected
                amoun.Disable = true
              }
              if (tys.includes(item.Property.Title[0].Text)) {
                phase.Value = reachCondition.PhaseCorrespondence.Key
                phase.Disable = true
                item.IsShow = true
                for (let child of item.Config.Table.Children) {
                  child.Property.Require = 1
                }
                continue
              }

              for (let i = table.Children.length - 1; i >= 0; i--) {
                let child = table.Children[i]
                let text = child.Property.Title[0].Text
                if (text === "是否发函" || text === "是否法务起诉" || text === "是否已开具发票" || text === "是否当月已和甲方核对佣金" || text === "预计实收日期" || text === "第几次申请暂缓发函" || text === "是否已发法务/律师函" || text === "第几次申请暂缓诉讼") {
                  child.Property.Require = 1
                }
                if (this.djyShow.indexOf(text) === -1) {
                  child.IsShow = false
                }
              }
              phase.Value = reachCondition.PhaseCorrespondence.Key
              phase.Disable = true
            }
          }
          if (Text === "附件") {
            if (File) {
              item.Values = [[File.Val]]
              item.fileNames = [{ "key": File.Key, "val": File.Val, "time": File.Time, "type": undefined }]
            }
            item.IsShow = true
          }
        }
        this.templateData = this.assignControl(template, this.logInfo);
        // 原始的长度
        const ylen = ReachConditionList.length
        const nonFwlen = ReachConditionList.filter(e => e.PhaseCorrespondence.Value !== "法务起诉").length
        that.selectState = 1
        if (ylen !== nonFwlen) {
          // 如果不一样 证明 法务起诉被选了 且被去掉了所以说length有变化 都有
          that.selectState = 3
        }
        if (nonFwlen === 0) {
          // 只选了法务起诉
          that.selectState = 2
        }
        // this.templateData.TemplateContent.Controls.filter(e => e.Property.Title[0].Text.indexOf("达结佣条件") !== -1 && e.IsShow).forEach(e => e['mark'] = "保留")
        this.listLoading = false;
      });
    },
    fwShow(fw) {
      let fwChild = fw.Config.Table.Children.filter(e => e.Property.Title[0].Text === "是否法务起诉")[0]
      fwChild.Property.Require = 1
      let children = fw.Config.Table.Children.filter(e => e.Property.Title[0].Text !== "是否法务起诉")
      children.forEach(child => {
        child.IsShow = false
      })
      fw.IsShow = true
    },
    fhShow(fh, selectValues) {
      let fhChild = fh.Config.Table.Children.filter(e => e.Property.Title[0].Text === "是否发函")[0]
      let fhChildSelector = fh.Config.Table.Children.filter(e => e.Property.Title[0].Text === "暂缓发函函件名称")[0]
      let fhChildAddess = fh.Config.Table.Children.filter(e => e.Property.Title[0].Text === "甲方收件人地址")[0]
      let options = fhChildSelector.Config.Selector.Options;
      fhChildAddess.Property.Placeholder[0].Text = "如:xx市xx区/镇xx街道xx号"
      fhChildSelector.Config.Selector.Options = options.filter(e => selectValues.indexOf(e.Value[0].Text) !== -1)
      fhChild.Property.Require = 1
      let children = fh.Config.Table.Children.filter(e => e.Property.Title[0].Text !== "是否发函")
      children.forEach(child => {
        child.IsShow = false
      })
      fh.IsShow = true
    },
    getEmployeeRelation: async function (approvalPerson) {
      await getRelation(approvalPerson).then(response => {
        this.relationList = response.Body[0].Nodes;
      });
    },
    getTextVal() {
    },
    getSelectorVal(val, name, a) {
    },
    showKJ(type, datas, selectName) {
      let item = null;
      let lsh = false;
      if (type == "是否已开具发票") {
        item = datas.Config.Table.Children.filter(e => e.Property.Title[0].Text == "发票")[0];
      }
      if (type == "是否当月已和甲方核对佣金") {
        item = datas.Config.Table.Children.filter(e => e.Property.Title[0].Text == "发展商盖章签字或微信确认的《佣金明细表》")[0];
      }
      if (type == "是否已发法务/律师函") {
        item = datas.Config.Table.Children.filter(e => e.Property.Title[0].Text == "请附函及发函凭证")[0];
        lsh = true;
      }

      if (!item) {
        return;
      }
      if (selectName == "是") {
        item.IsShow = true
        item.Property.Require = 1
      } else {
        item.IsShow = false
        item.Property.Require = 0
      }
      if (lsh) {
        item.Property.Require = 0
      }
    },
    tableOperation(val, type, datas) {
      console.log('type', type);
      if (type === 'compute') {
        return;
      }
      if (type === "add") {
        this.tableoperation(val, type, datas, this);
        return;
      }
      let mapperMap = new Map()
      mapperMap.set("是否发函",
        [
          {
            "fh": ["合同中项目名称", "合同中甲方名称", "甲方收件人姓名", "甲方收件人地址", "甲方收件人电话", "签署公司"]
          },
          {
            "zhfh": ["暂缓发函函件名称", "暂缓截止时间", "暂缓原因"]
          }
        ]
      )
      mapperMap.set("是否法务起诉",
        [
          {
            "qs": ["法务介入跟进金额"]
          },
          {
            "zhqs": ["暂缓截止时间", "暂缓原因"]
          }
        ]
      )
      let child = datas.Config.Table.Children.filter(e => e.Property.Title[0].Text === type)[0]
      // 拿到选择框选择的值
      const selectName = getOptionValForDataVal(val, child);
      this.showKJ(type, datas, selectName);

      // 根据这个值找到对应规则
      const selectMappers = mapperMap.get(type);
      if (!selectMappers) {
        return;
      }
      for (let selectMapper of selectMappers) {
        // 获取类型
        let typeName = this.getType(selectName)
        // 获取需要显示的列表
        const showLists = selectMapper[typeName]
        if (showLists === undefined) continue
        for (const item of datas.Config.Table.Children.filter(e => e.Property.Title[0].Text !== type)) {
          const name = item.Property.Title[0].Text;
          if (this.djyShow.includes(name)) {
            continue;
          }
          // 包含在显示列表中的就显示 否则 隐藏
          if (showLists.includes(name)) {
            if (name === "法务介入跟进金额") {
              item.Value = this.money
            }
            item.IsShow = true
            item.Property.Require = 1
          }
          if (!showLists.includes(name)) {
            if (Object.keys(item).filter(e => e === "ValuesSelect").length > 0) {
              item.ValuesSelect = []
            }
            item.IsShow = false
            item.Value = null
            item.Property.Require = 0
          }
        }
      }
    },
    // 获取类型
    getType(name) {
      switch (name) {
        case "发函":
          return "fh"
        case "暂缓发函":
          return "zhfh"
        case "起诉":
          return "qs"
        case "暂缓起诉":
          return "zhqs"
      }
    },
    submit() {
      this.isDisabled = true

      //数据校验
      if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
        this.isDisabled = false
        return;
      }
      this.test()
      const conent = this.templateData.TemplateContent;

      for (let control of conent.Controls.filter(e => e.Property.Title[0].Text.indexOf("达结佣条件") !== -1)) {
        let table = control.Config.Table
        for (let child of table.Children) {
          if (child.Property.Title[0].Text.indexOf("法务介入跟进金额") !== -1) {
            if ((child.Value < this.money) && child.IsShow) {
              this.Message({
                message: '法务介入跟进金额,不能少于交管填写的"业务系统未收总金额"',
                type: 'error',
                duration: 2000
              });
              this.isDisabled = false
              return;
            }
          }
        }
      }
      // Keep the full editable form before removing submission-only fields.
      const contentBackup = JSON.parse(JSON.stringify(conent));
      /*if (!this.isZong) {*/
      for (let item of this.templateData.TemplateContent.Controls) {
        if (item.Property.Title[0].Text === "逐级审批使用") {
          const values = item.Values
          if (JSON.stringify(values).indexOf("SC24000029") !== -1) {
            const len = values.length;
            item.Values = values.slice(0, len - 1)
          }
        }
      }
      /*} else {
        for (let item of this.templateData.TemplateContent.Controls) {
          if (item.Property.Title[0].Text === "逐级审批使用") {
            const values = item.Values
            if (JSON.stringify(values).indexOf("SC24000029") === -1) {
              var value = ["SC24000029", "钟志斌"]
              item.Values.push(value)
            }
          }
        }
      }*/

      for (let control of conent.Controls) {
        if (control.Property.Title[0].Text.indexOf("达结佣条件") !== -1) {
          let table = control.Config.Table
          for (let child of table.Children) {
            child.Property.Require = 0
          }
        }
      }

      for (let control of conent.Controls) {
        if (control.Property.Control === "File") {
          delete control.fileNames
        }
      }

      var SummaryList = [];
      var info = { SummaryInfo: [] }
      info.SummaryInfo = [];
      info.SummaryInfo.push({ "Text": "选择所在部门：" + this.logInfo.DeptName, "Lang": "zh_CN" });
      SummaryList.push(info);
      var control3 = this.templateData.TemplateContent.Controls.filter(t => {
        return t.Property.Title[0].Text === "项目名称"
      })[0]
      var info = { SummaryInfo: [] }
      info.SummaryInfo = [];
      info.SummaryInfo.push({ "Text": "项目名称：" + control3.Value, "Lang": "zh_CN" });
      SummaryList.push(info);

      this.templateData.SummaryList = SummaryList

      if (isSubmit) {
        this.Message({
          message: '已提交',
          type: 'warning',
          duration: 1000
        });
        return;
      }
      isSubmit = true;
      this.listLoading = true;
      //提交
      submitProcess(
        this.templateId,
        this.logInfo.EmpNo,
        this.spNo,
        this.templateData,
        this.flowId
      ).then(response => {
        this.Message({
          message: '申请成功',
          type: 'success',
          duration: 3 * 1000
        });
        updateState(this.flowId, 200)
        setTimeout(() => {
          this.$router.push("/index");
        }, 3000)
      }).catch(e => {
        this.isDisabled = false
        this.templateData.TemplateContent = contentBackup
      }).finally(() => {
        isSubmit = false;
        this.listLoading = false;
      });
    }
  }
}
</script>

<style scoped lang="less">
.pages {
  padding-bottom: 14px;
}
</style>
